/*
Akhila 03/20/2023 2699762545 added letter format stepper
Guru Prasad 03/20/2023 2699762545 Fixed Buttons UI
Sohel 03/22/2023 2698964415 Letter Field Payload Changes
Akhila 03/23/2023 2698964415 added letter format print now save api
Akhila 03/24/2023 2699762545 modified condition to "Mail Merge"
Sohel 03/25/2023 2699762545 File Upload Changes
Akhila 03/25/2023 2699762545 Added condition in upload file prepopulating
Dilip 03/27/2023 2699762545 added bredcrums to show code and description
Akhila 03/27/2023 2699762545 Added save button
Sohel 03/27/2023 2699762545 Print Now prepopulate issue
Akhila 03/27/2023 2699762545 print now conditon bug fix
Akhila 03/28/2023 2699762545 Added file size validation
Sohel 03/30/2023 2699762545 Change letter Type Value
Sohel 04/10/2023 3225736869 Fixed Letter Type Payload Changes
Prakash 11-04-23 2699762545 remove white space issue in letter maintainance
Akhila 05/24/2024 2699762545 role access implemeneted
Akhila 05/30/2023 2699762545 unsaved changes bug fixed
Ravi 06/21/2023 2699762545 fixed submit issue
*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import {CKEditor} from 'ckeditor4-react';
import {Formik, Form} from 'formik';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {
  fetchLetterFormatData,
  postLetterFormat,
  resetLetterFormat,
  postLetterFormatPrint,
} from '../../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import {
  Button,
  Grid,
} from '@material-ui/core';
import * as Yup from 'yup';
import {useSelector, useDispatch} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import DragAndDrop from './DragDrop';
import BreadCrums from '../../../../util/BreadCrum';
import {submissionStart} from '../../../../redux/reducers/CommonActions/commonActions';

function LetterFormat({
  handleBack,
  handleNext,
  hidden,
  handleDirty,
  LetterMainAccess,
  editExisting,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [fileSizeError, setFileSizeError] = useState(false);
  const [filePathName, setFilePathName] = useState('');
  const [condition, setCondition] = useState(false);
  const [contentText, setContentText] = useState('');
  const saveRef = useRef();
  const {
    basicInfoData,
    letterCode,
    letterFieldsSuccessMsg,
    letterFieldsErrorMsg,
    letterFieldsStatus,
    letterFormatData,
    isLetterFieldsLoading,
  } = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const dispatch = useDispatch();
  const handleDialog = () => {
    // setOpenTemplate(true);
    // if (code && communicationDetails?.documentKey) {
    //   dispatch(getTemplateDocumentLink(communicationDetails?.documentKey));
    // }
  };
  const initialVal = {
    contentText: letterFormatData?.contentText ? letterFormatData?.contentText : '',
    uploadedFile: null,
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  useEffect(() => {
    // setInitialValues({
    //   ...initialVal,
    //   contentText: letterFormatData?.contentText ? letterFormatData?.contentText : "",
    // });
    if (letterFormatData?.contentText) {
      setContentText(letterFormatData?.contentText);
    }
  }, [letterFormatData?.contentText]);
  useEffect(() => {
    if (letterFormatData?.contentText) {
      setTimeout(() => {
        setCondition(true);
      }, 1000);
    }
  }, [letterFormatData]);
  useEffect(() => {
    setCondition(false);
  }, []);
  const getPrintNowEditor = (values, setFieldValue) => {
    return (
      <CKEditor
        initData={`${values}`}
        name="contentText"
        id="contentText"
        config={{
          removePlugins: 'elementspath',
          extraPlugins: `justify,font,colorbutton`,
          toolbarGroups: [
            {
              name: 'document',
              groups: ['mode', 'document', 'doctools'],
            },
            {
              name: 'clipboard',
              groups: ['clipboard', 'undo'],
            },
            {
              name: 'editing',
              groups: ['find', 'selection', 'spellchecker'],
            },
            {name: 'forms'},
            '/',
            {
              name: 'basicstyles',
              groups: ['basicstyles', 'cleanup'],
            },
            {
              name: 'paragraph',
              groups: ['list', 'indent', 'blocks', 'align', 'bidi'], // 'align' -> 'justify' plugin
            },
            {name: 'links'},
            {name: 'insert'},
            '/',
            {name: 'styles'}, // 'font and fontsize' -> 'font' plugin
            {name: 'colors'}, // 'colors' -> 'colorbutton' plugin
            {name: 'tools'},
            {name: 'others'},
            {name: 'about'},
          ],
        }}
        onBeforeLoad={(CKEDITOR) => {
          CKEDITOR.on('instanceReady', function(event) {
            event.editor.on('beforeCommandExec', function(event) {
              // Show the paste dialog for the paste buttons and right-click paste
              if (event.data.name == 'paste') {
                event.editor._.forcePasteDialog = true;
              }
              // Don't show the paste dialog for Ctrl+Shift+V
              if (
                event.data.name == 'pastetext' &&
                event.data.commandData.from == 'keystrokeHandler'
              ) {
                event.cancel();
              }
            });
          });
        }}
        onChange={(e, value) => {
          // console.log(e.editor.getData(), "valueOnchage");
          // if (e.editor.getData() != "") {
          //   // setErrorEmail(false);
          // }
          setFieldValue(e.editor.getData());
          // setEmailData(e.editor.getData());
        }}
      />
    );
  };
  const schema = Yup.object().shape({
    uploadedFile:
      basicInfoData?.letterType === 'Word Merge' &&
      Yup.mixed()
        .test('uploadedFile', 'Please upload the file', (value) => {
          if (!value?.length && !filePathName) {
            return false;
          } else {
            return true;
          }
        })
        .nullable(),
  });

  useEffect(() => {
    if (letterFieldsErrorMsg || letterFieldsSuccessMsg) {
      setTimeout(() => {
        dispatch(resetLetterFormat());
        if (letterFieldsStatus === 200 && letterFieldsSuccessMsg && !saveRef.current) {
          handleNext();
        } else if (letterFieldsStatus === 200 && letterFieldsSuccessMsg && saveRef.current) {
          dispatch(fetchLetterFormatData(letterCode));
        }
      }, 1500);
    }
  }, [letterFieldsErrorMsg, letterFieldsSuccessMsg]);
  const handleSubmit = (values) => {
    if (
      letterFormatData?.name === values?.uploadedFile?.[0]?.name &&
      basicInfoData?.letterType === 'Word Merge'
    ) {
      handleNext();
    } else if (basicInfoData?.letterType === 'Word Merge') {
      dispatch(submissionStart());
      const formData = new FormData();
      formData.append('file', values?.uploadedFile?.[0]);
      formData.append(
        'letterFormatRequest',
        new Blob(
          [
            JSON.stringify({
              letterCode: letterCode,
              letterType: 'Word Merge',
              isDraft: basicInfoData?.isDraft === 'N' ? 'N' : 'Y',
              lastStep: basicInfoData?.lastStep > 5 ? basicInfoData?.lastStep : 5,
            }),
          ],
          {type: 'application/json'},
        ),
      );
      dispatch(postLetterFormat(formData));
    } else if (basicInfoData?.letterType === 'Text Merge') {
      dispatch(submissionStart());
      const payload = {
        contentText: contentText || '',
        letterCode: letterCode,
        letterType: basicInfoData?.letterType ? basicInfoData?.letterType : '',
        isDraft: basicInfoData?.isDraft === 'N' ? 'N' : 'Y',
        lastStep: basicInfoData?.lastStep > 5 ? basicInfoData?.lastStep : 5,
      };
      dispatch(postLetterFormatPrint(payload));
    }
  };
  useEffect(() => {
    if (letterCode) {
      dispatch(fetchLetterFormatData(letterCode));
    }
  }, [letterCode]);
  console.log(contentText, 'ContentText');
  return (
    <>
      <div className="mb-2">
        <BreadCrums
          name={'Letter Code'}
          code={basicInfoData?.letterCode}
          description={'Letter Description'}
          descriptionValue={basicInfoData?.letterDescription}
        />
      </div>
      <Formik
        initialValues={initialVal}
        validationSchema={schema}
        onSubmit={(values) => handleSubmit(values)}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            handleSubmit,
            setFieldValue,
            errors,
          } = props;
          return (
            <Form>
              {basicInfoData?.letterType === 'Word Merge' && (
                <div className={`${'col'}`}>
                  <Grid container className="global-field-textfields" spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <DragAndDrop
                        selectedFile={values?.uploadedFile}
                        setSelectedFile={setFieldValue}
                        error={errors.uploadedFile}
                        helperText={errors && errors.uploadedFile}
                        oldFile={
                          values?.uploadedFile?.[0]?.name ?
                            values?.uploadedFile?.[0]?.name :
                            letterFormatData?.fileName ?
                              letterFormatData?.fileName :
                              ''
                        }
                        viewIconCond={letterFormatData?.docKey}
                        viewhandler={handleDialog}
                        setFilePathName={setFilePathName}
                        values={values}
                        fileSizeError={fileSizeError}
                        setFileSizeError={setFileSizeError}
                      />
                    </Grid>
                  </Grid>
                </div>
              )}
              <div>
                {basicInfoData?.letterType === 'Text Merge' && condition ?
                  getPrintNowEditor(contentText, setContentText) :
                  basicInfoData?.letterType === 'Text Merge' && !letterFormatData?.letterFormatId ?
                    getPrintNowEditor(contentText, setContentText) :
                    ''}
              </div>
              <div className="d-flex justify-content-center mt-2 new-standard-textfields">
                <Button
                  variant="outlined"
                  onClick={() => {
                    handleBack();
                  }}
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && ( */}
                <Button
                  variant="outlined"
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                  onClick={() => {
                    handleSubmit();
                    saveRef.current = true;
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="submit"
                  disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                  onClick={() => {
                    saveRef.current = false;
                  }}
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                >
                  Save & Next
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
      {isLetterFieldsLoading && <PageLoader />}
      {letterFieldsErrorMsg && <ErrorSnackbar errorMsg={letterFieldsErrorMsg} />}
      {letterFieldsSuccessMsg && <SuccessSnackbar successMsg={letterFieldsSuccessMsg} />}
    </>
  );
}
export default LetterFormat;
